import { Row, Col, Card } from 'antd';
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons';
import { t } from 'i18next';

const MarketCards = () => {
  return (
    <Row
      gutter={[16, 16]}
      justify="center"
      style={{ margin: '32px 0' }} 
    >
      <Col xs={24} sm={12} md={8}>
        <a
          href="https://apps.apple.com/us/app/sktech/id6738701533"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Card
            hoverable
            bordered={false}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '16px',
              borderRadius: '12px',
              background:"linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)"
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AppleOutlined style={{ fontSize: 36, color: '#000' }} />
              <div style={{ marginLeft: 12 }}>
                <div style={{ fontSize: 12, color: '#000', lineHeight: 1 }}>
                  {t("Downloadonthe")}
                </div>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#000', lineHeight: 1.2 }}>
                  App Store
                </div>
              </div>
            </div>
          </Card>
        </a>
      </Col>

      <Col xs={24} sm={12} md={8}>
        <a
          href="https://play.google.com/store/apps/details?id=app.sunpoint.sktech"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Card
            hoverable
            bordered={false}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '16px',
              borderRadius: '12px',
              background:"linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)"
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AndroidOutlined style={{ fontSize: 36, color: '#44f244' }} />
              <div style={{ marginLeft: 12 }}>
                <div style={{ fontSize: 12, color: '#fff', lineHeight: 1 }}>
                  {t("Downloadonthe")}
                </div>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#fff', lineHeight: 1.2 }}>
                  Google Play
                </div>
              </div>
            </div>
          </Card>
        </a>
      </Col>
    </Row>
  );
};

export default MarketCards;
